import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_AXIOS_URL
})

// request interceptor, check for token and add it to the request headers
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Token ${token}`
    }
    return config
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  }
)

export default instance
